var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticClass: "operations", staticStyle: { "margin-top": "5px" } },
          [
            _c("div", { staticClass: "triggers" }, [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "1" },
                      on: { click: _vm.toQuery }
                    },
                    [_vm._v(_vm._s(_vm.$t("FileHistory.Refresh")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "2" },
                      on: {
                        click: function($event) {
                          _vm.cloudFile.visible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("FileHistory.Upload")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", no: "3" },
                      on: { click: _vm.remove }
                    },
                    [_vm._v(_vm._s(_vm.$t("FileHistory.Delete")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "4" },
                      on: { click: _vm.download }
                    },
                    [_vm._v(_vm._s(_vm.$t("FileHistory.BatchDownload")))]
                  ),
                  _vm.ingotUploadButton
                    ? _c("el-button", { attrs: { type: "primary", no: "5" } }, [
                        _vm._v(_vm._s(_vm.$t("FileHistory.ingotUpload")))
                      ])
                    : _vm._e(),
                  _vm.ingotButton
                    ? _c("el-button", { attrs: { type: "primary", no: "6" } }, [
                        _vm._v(_vm._s(_vm.$t("FileHistory.ingotLog")))
                      ])
                    : _vm._e()
                ],
                1
              )
            ])
          ]
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              staticStyle: { flex: "1", width: "100%", height: "100%" },
              attrs: {
                "show-side-bar": false,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData,
                no: "7"
              },
              on: {
                gridReady: function(params) {
                  return (_vm.gridApi = params.api)
                }
              }
            })
          ],
          1
        )
      ]),
      _c("cargo-cloud-file-upload", {
        attrs: {
          visible: _vm.cloudFile.visible,
          job: _vm.cloudFile.job,
          lob: _vm.cloudFile.lob,
          no: "8"
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          },
          uploadDone: _vm.updateSop
        }
      }),
      _vm.isShowingDetailForm
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                "close-on-click-modal": false,
                visible: _vm.isShowingDetailForm,
                title: _vm.showDetailTitle,
                "append-to-body": "",
                width: "200px;"
              },
              on: {
                "update:visible": function($event) {
                  _vm.isShowingDetailForm = $event
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    height: "350px"
                  }
                },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { flex: "1", width: "100%", height: "100%" },
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.gridOptionsFileDetail,
                      "column-defs": _vm.columnDefsFileDetail,
                      "row-data": _vm.rowDataFileDetail,
                      no: "9"
                    },
                    on: {
                      gridReady: function(params) {
                        return (_vm.gridApiFileDetail = params.api)
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }